import React from 'react'
import style from './style.module.scss'
import teamImg from '@assets/images/ipl/team.png'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'

const IPLTeams = ({ team, isMobile }) => {
  return (
    <div className='mt-4'>
      <h4>All Teams</h4>
      <div className={style.team}>
        {team?.map((item, i) => {
          return (
            <CustomLink href={item?.oSeo?.sSlug} key={i} >
              <a>
              <div className={style.teamBox} >
                <MyImage src={getImgURL(item?.oImg?.sUrl) || teamImg} alt='Team Name' width={90} height={90} className={style.teamBox_Image}/>
                <span className={style.teamText}>{item.sTitle}</span>
              </div>
              </a>
            </CustomLink>)
        })}
      </div>
      <div className='d-flex d-md-none'>
        <div className={style.teamMweb}>
          {team?.map((item, i) => {
            if (!isMobile) {
              return <CustomLink href={item?.oSeo?.sSlug} key={i} >
                <a>
                <div className='d-flex flex-column gap-2 cursor-pointer' >
                  <div className={style.teamBorder}>
                    <MyImage src={getImgURL(item?.oImg?.sUrl) || teamImg} alt='Team Name' width={60} height={60} className={style.teamBox_Image} />
                  </div>
                  <span className={style.teamText}>{item.sTitle}</span>
                </div>
                </a>
              </CustomLink>
            } else {
              return <div className='d-flex flex-column gap-2' key={i}>
                <div className={style.teamBorder}>
                  <MyImage src={getImgURL(item?.oImg?.sUrl) || teamImg} alt='Team Name' width={60} height={60} className={style.teamBox_Image} />
                </div>
                <span className={style.teamText}>{item.sTitle}</span>
              </div>
            }
          })}
        </div>
      </div>
    </div>
  )
}

IPLTeams.propTypes = {
  team: PropTypes.array,
  isMobile: PropTypes.bool
}

export default IPLTeams
